var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfWord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 64,
    height: 64,
    rx: 12,
    transform: "rotate(180 64 64)",
    fill: "#C6E1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30.3334C22 25.6193 22 23.2623 23.4645 21.7978C24.9289 20.3334 27.286 20.3334 32 20.3334H37C41.714 20.3334 44.0711 20.3334 45.5355 21.7978C47 23.2623 47 25.6193 47 30.3334V38.6667C47 43.3808 47 45.7378 45.5355 47.2022C44.0711 48.6667 41.714 48.6667 37 48.6667H32C27.286 48.6667 24.9289 48.6667 23.4645 47.2022C22 45.7378 22 43.3808 22 38.6667V30.3334Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40H41",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35H41",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H41",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 43.6667C19.2386 43.6667 17 41.4281 17 38.6667V28.6667C17 22.3813 17 19.2386 18.9526 17.286C20.9052 15.3334 24.0479 15.3334 30.3333 15.3334H37C39.7614 15.3334 42 17.572 42 20.3334",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfWord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-word.c068fd0d53adfada169bf0357dddf235.svg";